/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Cpf_RequiredInputs */

const en_clients_validation_cpf_required = /** @type {(inputs: Clients_Validation_Cpf_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPF is required.`)
};

const pt_br2_clients_validation_cpf_required = /** @type {(inputs: Clients_Validation_Cpf_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPF é obrigatório.`)
};

/**
* | output |
* | --- |
* | "CPF is required." |
*
* @param {Clients_Validation_Cpf_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_cpf_required = /** @type {((inputs?: Clients_Validation_Cpf_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Cpf_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_cpf_required(inputs)
	return pt_br2_clients_validation_cpf_required(inputs)
});